module.exports = __webpack_public_path__ + "img/logo-mobile-dark.150b94f1.svg";